import React from 'react';
import { useConfig } from '../../contexts/ConfigContext.jsx';

const BottomBar = () => {
  const { config } = useConfig();

  return (
    <div className="h-10 bg-surface border-t border-subtle flex items-center px-4 text-xs text-muted tracking-wider">
      
      <span className="font-mono mr-4 flex-shrink-0">
        Ready
      </span>

      <div className="marquee-container flex-1">
        <div className="marquee-content whitespace-nowrap">
          <span className="font-mono">
            {config.system?.bottomBarMessage}
          </span>
        </div>
      </div>

      <span className="ml-4 font-mono flex-shrink-0">
        System Online
      </span>
      
    </div>
  );
};

export default BottomBar;
